'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _titleSection = require('./common/title-section');

var _titleSection2 = _interopRequireDefault(_titleSection);

var _bodySection = require('./common/body-section');

var _bodySection2 = _interopRequireDefault(_bodySection);

var _ctaSection = require('./common/cta-section');

var _ctaSection2 = _interopRequireDefault(_ctaSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = _react2['default'].createClass({
    displayName: 'Online Signature App SEO Page',

    renderTitleSection: function renderTitleSection() {
        var titleSectionProps = {
            title: 'Using Online Signature Apps',
            subtitle: 'HelloSign is a free eSignature app providing a fast, simple, and secure way to sign online',
            buttonText: 'CREATE A FREE ACCOUNT'
        };
        return _react2['default'].createElement(_titleSection2['default'], _extends({}, titleSectionProps, this.props));
    },

    renderBodySection: function renderBodySection() {
        var headerClass = 'm-marketing-page--header';
        var listClass = 'm-marketing-page--list';
        return _jsx(_bodySection2['default'], {}, void 0, _jsx('h2', {
            className: headerClass
        }, void 0, 'Is HelloSign an Online Signature App?'), _jsx('p', {}, void 0, 'We sure are! HelloSign was founded in 2013 and has since helped hundreds of thousands of people safely and securely sign their documents online. You can learn a little more about what we do by visiting our ', _jsx('a', {
            href: 'https://www.hellosign.com/info/tour',
            target: '_blank'
        }, void 0, 'Tour Page.')), _jsx('h2', {
            className: headerClass
        }, void 0, 'Can I use the HelloSign signature app to sign on my mobile phone?'), _jsx('p', {}, void 0, 'Yes! Our online signature app is optimized for all your devices, including mobile phones. You can also use HelloSign to sign from your desktop or your tablet. Each device will give you an optimized signer experience that helps you efficiently navigate through any document you need to prepare or sign.'), _jsx('h2', {
            className: headerClass
        }, void 0, 'What sets HelloSign apart as an online signature app?'), _jsx('p', {}, void 0, 'One of the biggest differentiators at HelloSign is our user-friendly interface. We know admin applications can get hairy and complicated pretty quickly. So our goal has always been to provide a tool that’s both functional and easy to use! This continues to be top priority as as we add new features and integrating with new companies.'), _jsx('h2', {
            className: headerClass
        }, void 0, 'What are some of your most valuable features?'), _jsx('p', {}, void 0, 'Hard pressed, we’d have to say some of our most valuable features include:'), _jsx('ul', {
            className: listClass
        }, void 0, _jsx('li', {}, void 0, 'Data Validation'), _jsx('li', {}, void 0, 'Automation features like “Insert Signature Everywhere”'), _jsx('li', {}, void 0, 'User permissions'), _jsx('li', {}, void 0, 'In-person signing')), _jsx('p', {}, void 0, 'But we have a whole squad of features that help users create their very best signing experience. You can learn about all our ', _jsx('a', {
            href: 'https://www.hellosign.com/info/tour',
            target: '_blank'
        }, void 0, 'features here'), '!'), _jsx('h2', {
            className: headerClass
        }, void 0, 'Does your signature app integrate with any other companies?'), _jsx('p', {}, void 0, 'We do! We’ve integrated with quite a few companies over the years to bring online signing directly to the applications you use most. Since our first integration with Google, we’ve integrated with companies like ', _jsx('a', {
            href: 'http://blog.hellosign.com/dropbox/',
            target: '_blank'
        }, void 0, 'Dropbox'), ', ', _jsx('a', {
            href: 'http://blog.hellosign.com/hellosign-integrates-with-evernote/',
            target: '_blank'
        }, void 0, 'Evernote'), ', Box, ', _jsx('a', {
            href: 'http://blog.hellosign.com/hellosign-launches-integration-with-slack/',
            target: '_blank'
        }, void 0, 'Slack'), ', and the ', _jsx('a', {
            href: 'http://blog.hellosign.com/hellosign-and-hubspot-join-forces/',
            target: '_blank'
        }, void 0, 'HubSpot CRM'), '.'));
    },

    renderCTASection: function renderCTASection() {
        var ctaSectionProps = {
            title: 'Try The HelloSign App',
            subtitle: 'We’d love to have you take a look! You can create a free account and start signing in under 5 minutes. If you want to take a look at some of the features included in our Pro plans, visit our plan page.',
            signupButtonText: 'CREATE A HELLOSIGN ACCOUNT',
            signupButtonUrl: this.props.homeUrl,
            secondButtonText: 'SEE PRO PLANS',
            secondButtonUrl: this.props.pricingUrl
        };
        return _react2['default'].createElement(_ctaSection2['default'], _extends({}, ctaSectionProps, this.props));
    },

    render: function render() {
        return _jsx('div', {}, void 0, this.renderTitleSection(), this.renderBodySection(), this.renderCTASection());
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/online-signature-app.jsx
 ** module id = 826
 ** module chunks = 0
 **/